import { FeatureNameEnum } from 'constants-content';

import { FeatureDefinition } from '../FeatureDefinition';
import './UpdateFeatureRuleType';
import { UpdateCutoffUnitEnum } from './UpdateCutoffUnitEnum';

const Update: FeatureDefinition = {
  name: FeatureNameEnum.Update,
  friendlyName: 'web.content.feature.update.friendlyName',
  requiresInteraction: true,
  description: 'web.content.feature.update.description',
  properties: {
    rules: {
      friendlyName: 'web.content.feature.update.rules.friendlyName',
      description: 'web.content.feature.update.rules.description',
      type: 'UpdateFeatureRule',
      isArray: true,
      default: [
        {
          allGroupRoles: true,
          groupRoles: [],
          canUpdateAnytime: true,
          cutoffUnit: UpdateCutoffUnitEnum.Hour,
          cutoffValue: 1,
        },
      ],
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
};

export { Update as UpdateFeatureDefinition };
